/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { homeAction, shopAction } from "@redux/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

// Styles
import "./styles.scss";

// Mobilde uzun ürün isimleri bu karakter sayısından sonra "..." ile kesilir.
const MOBILE_NAME_MAX_LENGTH = 23;
const MOBILE_QUERY = "(max-width: 767px)";

const truncateName = (name, maxLength) =>
  name && name.length > maxLength ? `${name.slice(0, maxLength).trimEnd()}...` : name;

const HomeProduct = () => {
  const dispatch = useDispatch();
  const loginSettings = useSelector(
    (store) => store.auth.loginSettings
  );
  const productList = useSelector((store) => store.home.productList);
  const cartData = useSelector((store) => store.cart?.cartData);
  const categories = useSelector((store) => store.shop.categories);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const handleChange = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  useEffect(() => {
    dispatch(shopAction.getShopCategories("CATALOG"));
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (cartData?.length > 0) {
      if (
        productList &&
        productList.content &&
        productList.content.length > 0
      ) {
        for (const prod of productList.content) {
          for (const item of cartData?.cartProductDTOList) {
            if (prod.id === item?.product?.id) {
              prod.productCartCount = item?.productCount;
            }
          }
        }
      }
    }
    return () => {};
  }, [cartData, productList]);

  useEffect(() => {
    if (selectedCategory) {
      console.log("selectedCategory: ", selectedCategory);
    }
    return () => {};
  }, [selectedCategory]);

  useEffect(() => {
    dispatch(
      homeAction.getProductList("updateDate", "DESC", 0, 32, 0, selectedCategory || 0)
    );
    return () => {};
  }, [dispatch, selectedCategory]);

  const handleCategorySelect = (e, category) => {
    e.preventDefault();
    setSelectedCategory(category.id);
  };

  return (
    <section className="product-section pb-5 pt-5">
      <div className="container mb-5">
        <h1 className="text-center mb-0">Dükkan</h1>
      </div>

      <div className="container mb-sm-5 mb-4">
        <ul className="nav nav-pills justify-content-sm-center">
          {categories?.slice(0, 3).map((category) => (
            <li className="nav-item" key={category.id}>
              <a
                href="#"
                className={`nav-link${selectedCategory === category.id ? " active" : ""}`}
                onClick={(e) => handleCategorySelect(e, category)}
              >
                <span className="h5 mb-0">{category.name}</span>
              </a>
            </li>
          ))}
          <li className="nav-item">
            <Link to="/shop" className="nav-link">
              <span className="h5 mb-0">TÜMÜ</span>
            </Link>
          </li>
        </ul>
      </div>

      <div className="container product-grid">
        <div className="row">
          {productList &&
          productList.content &&
          productList.content.length > 0 ? (
            productList.content
              .slice(0, 6)
              .map((item) => {
              // Ayrıcalık ürününde havuz boşsa rozet "Yakında yeniden" olur; kart yine detaya gider.
              const CardTag = Link;
              const cardProps = { to: `/shop/${item.id}` };
              return (
              <div className="col-lg-4 col-6 mb-4" key={item.id}>
                <CardTag
                  {...cardProps}
                  className="item d-flex flex-sm-row flex-column align-items-sm-center align-items-center text-sm-start text-center pb-3 h-100 border-bottom d-block text-decoration-none"
                >
                  <img
                    src={
                      item?.productContentUrlList
                        ? item?.productContentUrlList[0].baseAddress
                        : loginSettings?.logo 
                    }
                    alt=""
                    className="img-contain"
                    style={{ width: "60px", height: "60px" }}
                  />
                  <div className="mt-sm-0 mt-3 ms-sm-3 ms-0 overflow-hidden">
                    <h6
                      className="fw-normal small mb-1 text-gray-darkest text-truncate"
                      title={item.name}
                    >
                      {isMobile
                        ? truncateName(item.name, MOBILE_NAME_MAX_LENGTH)
                        : item.name}
                    </h6>
                    {item.privilege ? (
                      <span className="privilege-badge">
                        {!item.privilegeAvailable && !item.privilegeCode
                          ? "Yakında yeniden"
                          : "Ayrıcalık"}
                      </span>
                    ) : (
                      <span className="small text-blue">{item.score}</span>
                    )}
                  </div>
                </CardTag>
              </div>
              );
            })
          ) : (
            <div className="col-12 text-center">
              <p>Bu kategoriye ait ürün bulunamadı.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
export default HomeProduct;
